<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component
        v-if="isError"
        :messages="messages"
        :error="isError"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="closeErrorMsg"/>
      <div class="columns is-multiline">
        <b-field :label="$t('addEditNomenclatureType.ajoutChamp.libelle')"
          class="obligatoire column is-6 mgb-0">
          <b-input v-model="champs.name"></b-input>
        </b-field>
        <b-field :label="$t('addEditNomenclatureType.ajoutChamp.type')"
          class="column is-6 mgb-0">
          <b-select v-model="champs.type" expanded>
            <option v-for="typeChamp in constantes.TYPE_PROPRERTIES"
              :key="typeChamp.code"
              :value="typeChamp.code">
              {{ $t(typeChamp.libelle) }}
            </option>
          </b-select>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <qd-button class="button is-addOrEdit" @click="handlerAdd">
              {{ $t('addEditNomenclatureType.ajoutChamp.addChamp') }}
            </qd-button>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { TYPE_PROPRERTIES } from '@/configuration/jsonEditor/jsonEditorConfig';
import genererChamps from '@/services/parametrage/generation/genererChamps';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  components: {
    errorMsgComponent,
  },
  props: {
    propertiesNames: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        TYPE_PROPRERTIES,
      },
      champs: genererChamps(),
      isError: false,
      messages: [],
    };
  },
  methods: {
    checkError() {
      this.messages = [];
      this.isError = false;
      if (this.champs.name === null || this.champs.name === '') {
        this.messages.push({
          message: 'addEditNomenclatureType.error.champs',
        });
      }
      if (this.champs.name !== null && this.propertiesNames.includes(this.champs.name)) {
        this.messages.push({
          message: 'addEditNomenclatureType.error.champsExist',
        });
      }
      if (this.messages.length > 0) this.isError = true;
    },
    handlerAdd() {
      this.checkError();
      if (this.isError) return;
      this.$emit('add', this.champs);
      this.$parent.close();
    },
    closeErrorMsg() {
      this.messages = [];
      this.isError = false;
    },
  },
};

</script>
